import { render, staticRenderFns } from "./defaultTree.vue?vue&type=template&id=1cd4d0a0&"
import script from "./defaultTree.vue?vue&type=script&lang=js&"
export * from "./defaultTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports